export default __webpack_public_path__ + "static/media/he-item-builder-mockup.7bac014c.png";